import { createFileRoute } from "@tanstack/react-router";
import { NotificationPrefsPanel } from "@/components/notification-prefs-panel";
import { PushDebugPanel } from "@/components/push-debug-panel";
import { Bell } from "lucide-react";
import { useTranslation } from "@/i18n";

export const Route = createFileRoute("/_authenticated/notifications")({
  head: () => ({ meta: [{ title: "Notification settings — BidNova Auctions" }] }),
  component: NotificationsPage,
  errorComponent: ({ error }) => <div className="p-6 text-rose-400">{(error as Error).message}</div>,
  notFoundComponent: () => <NotFound />,
});

function NotFound() {
  const { t } = useTranslation("activity");
  return <div className="p-6">{t("notifications.notFound", "Not found.")}</div>;
}

function NotificationsPage() {
  const { t } = useTranslation("activity");
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-80 bg-gradient-to-b from-primary/[0.06] via-transparent to-transparent" />
      <div className="relative mx-auto max-w-3xl px-4 sm:px-6 py-10 sm:py-14 space-y-6">
        <header>
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground/70">{t("notifications.eyebrow", "Account")}</p>
          <h1 className="mt-2 font-display text-4xl sm:text-5xl flex items-center gap-3">
            <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl">
              <Bell className="h-5 w-5 text-primary" />
            </span>
            {t("notifications.title", "Notifications")}
          </h1>
          <p className="mt-2 text-sm text-muted-foreground">{t("notifications.subtitle", "Manage how BidNova reaches you about bids, wins and shipments.")}</p>
        </header>
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-xl p-6">
          <NotificationPrefsPanel />
        </div>
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-xl p-6">
          <PushDebugPanel />
        </div>
      </div>
    </div>
  );
}
